import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16\"></path><path fill=\"#A2001D\" d=\"M8 0A8 8 0 0 0 .498 5.217h15.004A8 8 0 0 0 8 0\"></path><path fill=\"#0052B4\" d=\"M8 16a8 8 0 0 0 7.502-5.217H.498A8 8 0 0 0 8 16\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }